var React = require('react');

function IconArrowDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M1.03807 3.80866C1.11547 3.62182 1.29778 3.5 1.50001 3.5H10.5C10.7022 3.5 10.8846 3.62182 10.962 3.80866C11.0393 3.9955 10.9966 4.21055 10.8536 4.35355L6.35357 8.85355C6.15831 9.04882 5.84172 9.04882 5.64646 8.85355L1.14646 4.35355C1.00346 4.21055 0.960684 3.9955 1.03807 3.80866Z","fill":"currentColor"}));
}

IconArrowDown.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 12 12","fill":"none"};

module.exports = IconArrowDown;

IconArrowDown.default = IconArrowDown;
